export class SocialMediaRequestDTO {
    SessionId!: string;
    TargetSip!: string;
}